import React from "react";

/**
 * Simple container that sits inside the CRA dark header section.
 * It keeps the text readable and centered while preserving the default theme.
 */
export default function PageContainer({ children }) {
  return (
    <main
      style={{
        width: "100%",
        maxWidth: 960,
        padding: "1rem",
        marginTop: "1rem",
      }}
    >
      {children}
    </main>
  );
}
